<!--
  Вхід у розділ «Умови користування» — у футері стартової сторінки і на екранах
  оплати, під рядком «Продовжуючи, ви приймаєте правила сервісу».

  Ці два рядки не дублюють одне одного: «Продовжуючи…» веде в договір платника
  платіжної системи (зовнішній сайт LiqPay чи Portmone), а тут — оферта самого
  закладу з правилами повернення й реквізитами. Перед оплатою гостю потрібне
  саме друге, тож на екранах оплати посилання теж має бути.

  Формою повторює те, що робить Poster у своєму QR-меню: єдине неяскраве
  посилання внизу, без логотипів і без переліку документів. Усе інше —
  договір платника й логотип LiqPay — живе всередині самого розділу (Terms.vue).

  Закриває вимогу LiqPay до сайту мерчанта, п.3: правила оплати та повернення
  мають бути в окремому розділі, доступному з сайту.
-->
<template>
  <div class="terms-links">
    <a class="terms-links__item" :href="termsPageUrl">Умови користування</a>
  </div>
</template>

<script>
export default {
  name: "TermsLinks",
  computed: {
    // Перехід через параметр URL — той самий підхід, що й у
    // StartPage.openPay() з '&skyservice=pay'.
    termsPageUrl() {
      const url = new URL(window.location.href);
      url.searchParams.set("skyservice", "terms");
      return url.toString();
    },
  },
};
</script>

<style scoped>
.terms-links {
  display: flex;
  justify-content: center;
  /* Без падінгів: відступ від «Powered by» задає gap футера (4px, як у qr-menu). */
  padding: 0;
  color: inherit;
  /* Без явної ширини блок розтягується до min-content і розпирає сторінку. */
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

/* --text-head, а не inherit: успадкування підхоплювало колір посилань теми
   (на частині тем зелений), і рядок вибивався з «Powered by» поруч, який
   фарбується саме цим токеном. */
.terms-links__item {
  /* Шрифт задаємо тут, а не покладаємось на успадкування: базовий у #app —
     Helvetica Neue, і посилання бралo його у футері стартової, тоді як на
     екранах оплати .footerContainer віддає Manrope. У qr-menu Manrope стоїть
     глобально, тож канонічний саме він. */
  font-family: "Manrope", serif;
  /* Вагу теж фіксуємо, а не успадковуємо: у футерах оплати смуга задає 500 на
     контейнері, і посилання виходило важчим, ніж на стартовій. */
  font-weight: 400;
  font-size: 12px;
  line-height: 1;
  color: var(--text-head) !important;
  text-decoration: underline;
  opacity: 0.75;
}
</style>
